import React, { Component } from "react";
import {
    Card,
    Switch,
    Button,
    InputGroup,
    FormGroup,
    Icon,
    Spinner,
} from "@blueprintjs/core";

import {
    BASE_API,
    AppToaster,
    COLORS,
    SUBMENU,
} from "../../utils/constants";

import { withRouterParams } from "../../utils/withRouterParams";
import { getSession } from "../../utils/helpers";
import UiDialog from "../../components-fm/UiDialog";
import UISelect from "../../components-fm/UISelect";
import { setSession, isoToRo } from '../../utils/helpers'

import "../../css/SuperAdminDashboard.scss";
import { ro } from "date-fns/locale";
import { format, parseISO, differenceInYears, isValid } from "date-fns";
// în AdminEchipe.jsx
import TeamSummaryCard from "../echipa/TeamSummaryCard";


/** ex: "2003-08-13" + nume → "13 aug – Nume (21 ani)" dacă azi e 2025 */
function formatBirthdayOnThisYear(birth_date, name) {
    const dob = parseISO(birth_date);                 // data nașterii
    const y = new Date().getFullYear();               // anul curent

    // construim "aniversarea" din anul curent (YYYY-<lună>-<zi>)
    const month = Number(String(birth_date).slice(5, 7)) - 1; // 0-based
    const day = Number(String(birth_date).slice(8, 10));

    let anniv = new Date(y, month, day);

    // 29 feb în an nebisect → mutăm pe 28 feb
    if (!isValid(anniv)) anniv = new Date(y, 1, 28);

    const age = differenceInYears(anniv, dob);
    return `${format(anniv, "d MMM", { locale: ro })} – ${name} (${age} ani)`;
}

class AdminEchipe extends Component {
    state = {
        searchTerm: "",
        showAddDialog: false,
        teamName: "",
        addCoachToTeam: "",
        errors: { teamName: "" },
        isConfirmTeamDeleteOpen: false,
    };


    /* ───────────── Helpers UI ───────────── */
    handleSearch = (e) => this.setState({ searchTerm: e.target.value });
    getRandomColor = () => COLORS[Math.floor(Math.random() * COLORS.length)];
    toggleAddDialog = () => this.setState((p) => ({ showAddDialog: !p.showAddDialog }));
    toggleDeleteDialog = (team = null) => {
        this.setState((p) => ({
            isConfirmTeamDeleteOpen: !p.isConfirmTeamDeleteOpen,
            teamToBeDeleted: team,
        }));
    }
    /* ─────  Navigare la dashboard-ul echipei  ───── */
    openEchipaDashboard = (orgSlug, next_team) => {
        const firstTab = SUBMENU.echipa[0].slug; // "calendar"
        const session = getSession();
        console.log(session)
        let team = {}
        team.id = next_team.id;
        team.slug = next_team.slug;
        team.name = next_team.name;
        session.team = team;
        console.log(team.id, team.slug, team.name)
        // localStorage.setItem("session", JSON.stringify(session));
        setSession(session);

        this.props.navigate(
            `/echipa?org=${orgSlug}&echipa=${team.slug}&tab=${firstTab}`
        );
    };

    /* ─────  Validare form  ───── */
    handleInputChange = (e) => {
        const { name, value } = e.target;
        const errors = { ...this.state.errors };

        if (name === "teamName") {
            errors.teamName = /^[a-zA-Z0-9 \-_]+$/.test(value)
                ? ""
                : "Sunt permise doar litere, cifre, spații, _ și -";
        }
        this.setState({ [name]: value, errors });
    };

    isFormValid = () => this.state.teamName && !this.state.errors.teamName;

    /* -------------- add / delete team ------------------- */
    handleAddTeam = async () => {
        this.setState({ loading: true })
        this.toggleAddDialog(); // închide popup-ul
        let organizationId = this.props.organizationId;
        const coachId = this.state?.addCoachToTeam?.id || null;

        const { teamName } = this.state;
        try {
            const res = await fetch(`${BASE_API}/api/teams`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    organizationId,
                    teamName: teamName,
                    coachId
                }),
            });

            const data = await res.json();

            if (res.ok) {
                this.setState({ loading: false })
                AppToaster.show({
                    message: "Echipa a fost adăugată cu succes.",
                    intent: "success",
                    timeout: 3000,
                });
                this.props.getData(); // reîncarcă lista de echipe
            } else {
                AppToaster.show({
                    message: data.error || "Eroare la adăugarea echipei.",
                    intent: "danger",
                    timeout: 5000,
                });
            }
        } catch (err) {
            AppToaster.show({
                message: "Eroare de rețea.",
                intent: "danger",
                timeout: 5000,
            });
        }
    };

    confirmTeamDrop = (teamId) => {
        this.setState((prev) => ({
            isConfirmTeamDeleteOpen: !prev.isConfirmTeamDeleteOpen,
            teamToBeDeleted: teamId
        }));
    };

    handleTeamDrop = async () => {
        const { teamToBeDeleted } = this.state;
        // console.log(teamToBeDeleted)
        if (!teamToBeDeleted) {
            AppToaster.show({
                message: "Nicio echipă selectată.",
                intent: "danger",
                timeout: 5000,
            });
            return;
        }

        try {

            const res = await fetch(`${BASE_API}/api/teams/${teamToBeDeleted.id}`, {
                method: 'DELETE'
            });

            const data = await res.json();
            // console.log(data)
            if (res.ok) {
                AppToaster.show({
                    message: "Echipa a fost ștearsă cu succes.",
                    intent: "success",
                    timeout: 5000,
                });

                this.setState({ teamToBeDeleted: null }, this.props.getData);
            } else {
                AppToaster.show({
                    message: "Eroare: " + (data.error || "Nu s-a putut șterge echipa."),
                    intent: "danger",
                    timeout: 5000,
                });
            }
        } catch (err) {
            console.error(err);
            AppToaster.show({
                message: "Eroare de rețea.",
                intent: "danger",
                timeout: 5000,
            });
        }
        this.setState({ isConfirmTeamDeleteOpen: false })
    }

    isOpenPopupAddTeam = () => {
        this.setState({})
    }
    /*   păstrează implementările existente pentru            */
    /*   getTeams, getCoaches, handleAddTeam, handleTeamDrop  */

    /* ───────────── Render ───────────── */
    render() {
        // console.log('State...', this.state)
        // console.log('Props...', this.props)
        const {
            searchTerm,
            teamName,
            addCoachToTeam,
            errors,
            showAddDialog,
            isConfirmTeamDeleteOpen,
        } = this.state;

        const {
            teams = [],
            organizationName,
            organizationId,
            coaches,
        } = this.props;

        const filtered = teams.filter((t) =>
            t?.name?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        // console.log('filtered....', team)
        if (this.state.loading) return <Spinner />;
        if (this.state.error) return <p>{this.state.error}</p>;

        /* orgSlug pentru navigare */
        const orgSlug = getSession()?.organization?.organization_slug || "unknown-org";
        console.log(11111111111, teams)

        return (
            <div className="p-2-rem p-0-ss">
                {/* Header */}
                <div className="dashboard-header">
                    <div className="header-title">{organizationName}</div>
                    <div className="header-actions">
                        <InputGroup
                            leftIcon="search"
                            placeholder="Caută echipa..."
                            value={searchTerm}
                            onChange={this.handleSearch}
                        />
                        <Button
                            className="seagreen btn-medium"
                            onClick={this.toggleAddDialog}
                        >
                            Adaugă
                        </Button>
                    </div>
                </div>

                {/* Lista echipe + card extins hard-coded */}
                {filtered.length === 0 ? (
                    <p>Nu există echipe care corespund căutării.</p>
                ) : (
                    filtered.map((team) => (
                        <TeamSummaryCard
                            key={team.id}
                            team={team}
                            accentColor={this.getRandomColor()}
                            onClickTitle={() => this.openEchipaDashboard(orgSlug, team)}
                            onDelete={() => this.toggleDeleteDialog(team)}
                            showActions={true}
                        />
                    ))
                )}
                {/* Adauga Echipa */}
                <UiDialog
                    isOpen={showAddDialog}
                    onClose={this.isOpenPopupAddTeam}
                    title="Adaugă echipa"
                    footer={
                        <>
                            <Button className="alert-bordered btn-medium" onClick={this.isOpenPopupAddTeam}>Anulează</Button>
                            <Button className="seagreen btn-medium" onClick={this.handleAddTeam} disabled={!this.isFormValid()}>Salvează</Button>
                        </>
                    }

                >
                    <FormGroup label="Echipa" intent={errors.teamName ? "danger" : "none"} helperText={errors.teamName}>
                        <InputGroup name="teamName" value={teamName} onChange={this.handleInputChange} intent={errors.teamName ? "danger" : "none"} />
                    </FormGroup>
                    {this.props?.coaches &&
                        <FormGroup label="Selectează antrenor">
                            <UISelect
                                items={this.props?.coaches?.map(c => ({ id: c.id, name: c.name }))}
                                selectedItem={addCoachToTeam}
                                onItemSelect={(coach) => this.setState({ addCoachToTeam: coach })}
                                placeholder="Alege antrenor..."
                            />
                        </FormGroup>
                    }
                </UiDialog>


                {/* Delete confirm dialog */}
                <UiDialog
                    isOpen={isConfirmTeamDeleteOpen}
                    onClose={this.confirmTeamDrop}
                    title="Șterge organizație"
                    footer={
                        <>
                            <Button className="alert-bordered btn-medium" onClick={this.confirmTeamDrop}>Anulează</Button>
                            <Button className="alert btn-medium" onClick={this.handleTeamDrop}>Șterge</Button>
                        </>
                    }
                >
                    <div>
                        Confirmi ștergerea organizației <strong>{this.state.organizationToBeDeleted?.name}</strong>?
                    </div>
                </UiDialog>


                {/*  Dialoguri (add, delete) rămân neschimbate  */}
                {/*  — codul tău pentru UiDialog-uri este deja prezent mai jos — */}
            </div>
        );
    }
}

export default withRouterParams(AdminEchipe);
